import axios from "axios";

axios.defaults.headers.common = {
  "X-Requested-With": "XMLHttpRequest",
  "X-XSRF-TOKEN": window.csrf_token
};
axios.defaults.maxRedirects = 0;

export default class AxiosService {
  constructor() {
    const service = axios.create({
      headers: {
        "X-Requested-With": "XMLHttpRequest",
        "X-XSRF-TOKEN": window.csrf_token
      }
    });
    service.interceptors.response.use(this.handleSuccess, this.handleError);
    this.service = service;
  }

  handleSuccess(response) {

    // if (response.status === 302) {
    //   console.log("response-success-axios", JSON.stringify(response));
    // }

    // if (response.request) {
    //   if (response.request.responseURL) {
    //     if (response.request.responseURL.includes("login")) {
    //         window.location = "/oauth2/authorization/okta";
    //     }
    //   }
    // }

    return response;
  }

  // maybe to use it later... Better way is to handle errors in a service... Not in such a generic way...
  handleError(error) {
    if (error.response.status === 401) {
      const location = error.response?.headers?.location;
      if (location) {
        window.location = location;
      }
    }
    return Promise.reject(error);
  }

  redirectTo(document, path) {
    document.location = path;
  }

  get(path, config) {
    return this.service.get(path, config);
    // return this.service.get(path, {
    //   crossDomain: true
    // });
  }

  delete(path, payload) {
    return this.service.delete(path, payload);
  }

  post(path, payload, config) {
    return this.service.post(path, payload, config);
  }

  patch(path, payload) {
    return this.service.patch(path, payload);
  }

  put(path, payload, config) {
    return this.service.put(path, payload, config);
  }
}